export default {
  home: 'Home',
  contact: 'Contact Us',
  btnCreateAccount: 'Create Account',
};
